import { Box } from "@chakra-ui/react";
import React from "react";

export const DisplayQuestionContent: React.FC<{ content: string }> = ({
  content,
}) => {
  return <Box dangerouslySetInnerHTML={{ __html: content }} pl={3}></Box>;
};
